import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/portal/deposit-account/$depositAccountId/home/',
)({
  component: () => null,
  beforeLoad: () => {
    throw redirect({
      to: '/portal/deposit-account/$depositAccountId/home/transactions',
      from: '/portal/deposit-account/$depositAccountId/home/',
      replace: true,
    });
  },
});
